import { ApiBase } from "../../core/api-base";
import type * as z from "zod";
import { UploadAvatarBody } from "../../api/generated/users.zod";

export class AvatarApi extends ApiBase {
    public static uploadAvatar(file: z.infer<typeof UploadAvatarBody>["avatar"]): Promise<Response> {
        const formData = new FormData();
        formData.append("avatar", file);
        return super.apiPost("/api/v1/users/avatar", formData);
    }
}
